import React, {ReactElement} from "react";
import {ButtonBase, Card, Typography} from "@mui/material";
import {SiteTemplate} from "../../../../vantage-shared/page-components/types";
import {StyledBoxColumn} from "../../../../shared/StyledComponents";
import {PD_XLG} from "../../../../shared/dimens";
import defaultTemplate from "../../res/images/default_template.png";

export function SidebarContentTemplate(props: {
  templates: SiteTemplate[],
  selectedTemplateName: string,
  setSelectedTemplateName: (templateName: string) => void
}): ReactElement {
  return <StyledBoxColumn>
    {props.templates.map(template => <Card style={{width: "100%"}}>
      <ButtonBase
        onClick={() => {
          props.setSelectedTemplateName(template.name);
        }}
        style={{
          width: "100%",
          aspectRatio: 3 / 2,
        }}>
        <StyledBoxColumn style={{
          width: "100%",
          padding: PD_XLG,
          aspectRatio: 3 / 2,
          alignItems: "center",
          justifyContent: "center"
        }}>
          <img
            src={template.thumbnailUrl || defaultTemplate}
            style={{width: "100%", aspectRatio: 1, objectFit: "cover"}}/>
          <Typography>{template.text}</Typography>
        </StyledBoxColumn>
      </ButtonBase>
    </Card>)}
  </StyledBoxColumn>
}